import axios from 'axios';
import toastr from 'toastr';
import router from '../router'

class Api {

	constructor() {
		//Create the base service
		let service = axios.create({});

		//Set the access token
		service.interceptors.request.use((config) => {
			//Set the token
			//config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('amos_365_token', null);

			//Set form data to enable files
			config.headers.common['Content-Type'] = 'application/json';

			//Return ti
			return config;
		});

		//Set the default handler for errors
		service.interceptors.response.use(null, function(error) {
			//Handle the error status
			switch(error.response.status)
			{
				//Unauthorized
				case 401:
					//Redirect to login
                    //router.push('/login');
                    window.location = '/login';
					break;

				case 403: //Permission Issue
					//Send to not found
					router.push({
						name: '403',
						query: {
							permissions: error.response.data
						}
					});
					break;

				case 404:
					//Send to not found
					router.push('/404');
					break;

				case 409:
					//Send to billing page.
					router.push('/409');
					break;

				case 418:
					//Send it
					toastr.error(error.response.data);

					//Stop here
					//return;
					break;
				case 422:
					//Validation Error Happened
					toastr.error('Validation Errors Occurred. Check Required Fields.');
					break;
				case 500:
					//Send it
					toastr.error(error.response.data, 'Something Went Wrong');
					break;
			}

			//Return default promise
			return Promise.reject(error);
		});

		//Bind the service to this
		this.service = service;

		//Set the base url
		this.baseUrl = process.env.MIX_API_URL;
	}

	base(){
		return this.baseUrl;
	}

	cleanPath(path){
		//This trims any prefixed forward slashes
		if(path.substring(0, 1) === '/')
		{
			return path.substring(1);
		}

		//Return the path
		return path;
	}

	request(method, path, payload) {
		return this.service.request({
			method: method,
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: payload
		});
	}

	get(path, payload) {
		//Returns the promise
		return this.service.get(this.baseUrl + '/' + this.cleanPath(path), {params: payload});
	}

	getWeb(path, payload) {
		//Omit the Base URL
		return this.service.get('/' + this.cleanPath(path), {params: payload});

		return this.service.request({
			method: 'GET',
			url: `/${this.cleanPath(path)}`,
			responseType: 'json',
			data: payload
		});
	}

	patch(path, payload) {
		//Return the promise
		return this.service.request({
			method: 'PATCH',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: payload
		});
	}

	post(path, payload) {
		//Deactivating
		return this.service.request({
			method: 'POST',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: payload
		});
	}

	postWeb(path, payload) {
		return this.service.request({
			method: 'POST',
			url: `/${this.cleanPath(path)}`,
			responseType: 'json',
			data: payload
		});
	}

	postWithFiles(path, payload, files) {
		// //Creat the new formData
		var formData = this.convertModelToFormData(payload);

		//Append Files
		this.appendFilesRecurrsion(files, formData);

		//Send it
		return this.service.request({
			method: 'POST',
			url: this.baseUrl + '/' + this.cleanPath(path),
			//url: '/' + this.cleanPath(path),
			responseType: 'json',
			data: formData
		});
	}

	postWithSingleFile(path, payload, file) {
		var formData = this.convertModelToFormData(payload);

		if (file)
		{
        	formData.append('file', file);
		}

		//Send it
		return this.service.request({
			method: 'POST',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: formData
		});
	}

	patchWithFiles(path, payload, files) {
		// //Creat the new formData
		var formData = this.convertModelToFormData(payload);

		//Append Files
		this.appendFilesRecurrsion(files, formData);

        //Larvel Helper
        formData.append('_method', 'PATCH');

		//Send it
		return this.service.request({
			method: 'POST',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			//conentType: 'multipart/form-data',
			headers: {'Content-Type': 'multipart/form-data', 'enctype': 'multipart/form-data'},
			data: formData
		});
	}

	delete(path, payload) {
		return this.service.request({
			method: 'DELETE',
			url: this.baseUrl + '/' + this.cleanPath(path),
			responseType: 'json',
			data: payload
		});
	}

	appendFilesRecurrsion(files, formData, key = null){
		//Check for an array
		if(Array.isArray(files))
		{
			//Set the data
			for( var i = 0; i < files.length; i++ )
			{
				//Set the files
				let file = files[i];

				//SEtup
				var file_key = (key ? key : 'files') + '[' + i + ']';

				//Append
				formData.append(file_key, file);
			}
		}
		else
		{
			//Setup keys
			var keys = Object.keys(files);

			//Loop through and build lists
			for(var i = 0; i < keys.length; i++)
			{
			    //Check for Arry
			    if(Array.isArray(files[keys[i]]))
			    {
			    	this.appendFilesRecurrsion(files[keys[i]], formData, keys[i]);
			    }
			    else
			    {
			    	//Append
			    	formData.append(keys[i], files[keys[i]]);
			    }
			}
		}
	}

	convertModelToFormData(model, form = null, namespace = '') {
		//Setup
        let formData = form || new FormData();
        let formKey;

        //Check if we are on the first level of an array with a string value
        if(form && namespace != '' && typeof model != 'object')
        {
        	//Check for null
        	if(model != null && model != '')
        	{
        		formData.append(namespace, model);
        	}

        	//Stop Here
        	return;
        }

        for (let propertyName in model)
        {
            //Check for name
            //if (!model.hasOwnProperty(propertyName) || model[propertyName] == undefined || model[propertyName] == null) continue;

            //Setup the key
            let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

            //Build it
            if (model[propertyName] instanceof Date)
            {
                formData.append(formKey, model[propertyName].toISOString());
            }
            else if (model[propertyName] instanceof Array)
            {
                model[propertyName].forEach((element, index) => {
                    //Setup the Temp Key
                    const tempFormKey = `${formKey}[${index}]`;

                    //Recursion
                    this.convertModelToFormData(element, formData, tempFormKey);
                    //formData.append(tempFormKey, element.toString());
                });
            }
            else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            {
                this.convertModelToFormData(model[propertyName], formData, formKey);
            }
            else
            {
                //APpend
                if(typeof model[propertyName] !== undefined)
                {
                	formData.append(formKey, model[propertyName].toString());
                }
            }
        }

        return formData;
    }
}

export default new Api;